var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoP = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M85.054 45.274H71.13a3.204 3.204 0 0 0-3.201 3.207v28.97a3.204 3.204 0 0 0 3.201 3.206h13.924a3.204 3.204 0 0 0 3.201-3.207V48.481a3.204 3.204 0 0 0-3.201-3.207Z"
  }), React.createElement("path", {
    fill: color,
    d: "M68.125 78.36v-3.755H87.75v4.507l-1.625 1.502H69.75l-1.625-2.254ZM88 51.172H67.929V47.24l1.962-1.966h15.701L88 47.187v3.985Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M85.054 45.274H71.13a3.204 3.204 0 0 0-3.201 3.207v28.97a3.204 3.204 0 0 0 3.201 3.206h13.924a3.204 3.204 0 0 0 3.201-3.207V48.481a3.204 3.204 0 0 0-3.201-3.207ZM67.929 51.55h20.326"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M76.446 48.414h2.849"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M67.929 74.38h20.326"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m73.818 62.965 5.888-5.897M75.779 66.896l7.85-7.863"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m39.695 13.997-2.143 6.43 3.212-3.215 6.424-4.289 7.494-1.073 8.563 4.284-3.21-5.357-7.493-2.142-6.423 1.074-6.424 4.288Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m58.431 27.975-1.62 7.256s-.637 2.34 1.827 2.881c2.464.543 2.592-.53 2.883-1.831l1.13-5.05.491-2.202a2.416 2.416 0 0 0-1.828-2.886 2.416 2.416 0 0 0-2.883 1.832Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m63.187 28.782 1.868 1.255c.414.272.622.687.533 1.067l-.974 4.354c-.085.384-.45.668-.94.74l-2.236.363"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m63.187 28.782 1.868 1.255c.414.272.622.687.533 1.067l-.974 4.354c-.085.384-.45.668-.94.74l-2.236.363"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M40.931 35.834c-1.904-3.026-3.34-6.371-3.893-9.369-1.637-8.887 3.97-15.888 11.68-17.315 7.71-1.427 15.442 3.108 17.078 11.991.544 2.953.46 6.49-.21 9.95"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M37.421 28.12c-1.712-6.605 4.666-14.36 11.9-15.699 7.233-1.339 15.814 2.868 16.7 10.374"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M50.503 36.396c.736 1.116.664 2.449-.68 3.35-1.342.901-2.64-.018-3.346-.683-.705-.664-2.853-4.311-2.853-4.311L42.38 32.87a2.42 2.42 0 0 1 .68-3.35 2.412 2.412 0 0 1 3.345.68l4.098 6.196Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m42.25 32.654-1.298 1.84c-.29.403-.337.865-.118 1.19l.101.15 2.36 3.567c.215.328.658.463 1.141.354l2.218-.46"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m42.25 32.654-1.298 1.84c-.29.403-.337.865-.118 1.19l.101.15 2.36 3.567c.215.328.658.463 1.141.354l2.218-.46"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M18.182 61.717c1.043 20.246-.71 25.44-1.095 27.481a.487.487 0 0 0 .283.536c1.24.552 5.82 2.253 15.238 2.253 9.419 0 13.999-1.701 15.239-2.253a.487.487 0 0 0 .282-.536c-.386-2.041-2.137-7.236-1.094-27.48"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m18.343 65.189-2.502 4.458a.318.318 0 0 1-.31.166c-5.132-.516-7.838-3.31-8.455-4.028a.314.314 0 0 1-.04-.352c.574-1.073 3.531-6.628 5.63-10.989.873-1.812 2.228-3.899 6.365-4.954 4.985-1.27 7.213-3.689 7.213-3.689s3.076-.528 6.365-.528 6.365.528 6.365.528 2.228 2.42 7.213 3.689c4.138 1.054 5.493 3.142 6.364 4.954 2.1 4.361 5.057 9.918 5.63 10.99a.314.314 0 0 1-.039.351c-.617.718-3.323 3.512-8.456 4.028a.317.317 0 0 1-.31-.166l-2.495-4.38"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.343 65.189-2.502 4.458a.318.318 0 0 1-.31.166c-5.132-.516-7.838-3.31-8.455-4.028a.314.314 0 0 1-.04-.352c.574-1.073 3.531-6.628 5.63-10.989.873-1.812 2.228-3.899 6.365-4.954 4.985-1.27 7.213-3.689 7.213-3.689s3.076-.528 6.365-.528 6.365.528 6.365.528 2.228 2.42 7.213 3.689c4.138 1.054 5.493 3.142 6.364 4.954 2.1 4.361 5.057 9.918 5.63 10.99a.314.314 0 0 1-.039.351c-.617.718-3.323 3.512-8.456 4.028a.317.317 0 0 1-.31-.166l-2.495-4.38"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M44.633 68.606c-.896 7.179-.898 10.768-.898 13.46s.898 8.077 1.794 8.077h2.687v-1.795l-1.792-11.666V61.426s-.895 0-1.791 7.18ZM44.63 49.76a.082.082 0 0 1 .043-.021l1.75-.876 5.375 3.59 6.272 13.46-1.792 1.795c-1.792-3.889-5.734-12.205-7.168-14.358-.864-1.3-3.953-3.712-4.437-3.611l-.043.021ZM13.13 69.834l4.598-7.675v3.07l-2.299 4.605H13.13ZM29.224 49.879l-3.831-3.07.766-.768 1.533-.768h8.429l3.832 1.535-1.533.768-2.299 1.535-3.065.768h-3.832Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.343 65.189-2.502 4.458a.318.318 0 0 1-.31.166c-5.132-.516-7.838-3.31-8.455-4.028a.314.314 0 0 1-.04-.352c.574-1.073 3.531-6.628 5.63-10.989.873-1.812 2.228-3.899 6.365-4.954 4.985-1.27 7.213-3.689 7.213-3.689s3.076-.528 6.365-.528 6.365.528 6.365.528 2.228 2.42 7.213 3.689c4.138 1.054 5.493 3.142 6.364 4.954 2.1 4.361 5.057 9.918 5.63 10.99a.314.314 0 0 1-.039.351c-.617.718-3.323 3.512-8.456 4.028a.317.317 0 0 1-.31-.166l-2.495-4.38"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.182 61.717c.313 3.513.274 8.604.313 11.188m28.54-11.188c-1.043 20.244.709 25.439 1.094 27.48a.487.487 0 0 1-.282.536c-1.24.552-5.82 2.253-15.239 2.253-9.418 0-13.999-1.701-15.238-2.253a.487.487 0 0 1-.283-.536c.17-.899.782-4.424 1.095-8.617M39.61 46.374c0 1.74-3.967 3.49-7 3.49-3.034 0-7.002-1.75-7.002-3.49"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.196 76.742c2.539 0 5.365 2.83 5.365 5.373 0-2.543 2.825-5.373 5.364-5.373-2.539 0-5.364-2.83-5.364-5.373 0 2.543-2.826 5.373-5.365 5.373Z"
  }));
};
export default SvgTamanhoP;